export const SENTRY_TAGS = {
  RESERVATION_LIVE_ROOM: 'rlr',
}
